import type { PostHog } from "posthog-js"
import type { Properties } from "posthog-js"
import type { PostHogClientContext } from "@/lib/posthog/types"
import type { PostHogEventName } from "@/lib/posthog/types"

const MAX_PENDING_EVENT_COUNT = 50

export type PendingPostHogEvent = {
  eventName: PostHogEventName
  properties: Properties
}

export const postHogState = {
  capturedChatTimelineEventSignatures: new Set<string>(),
  client: null as PostHog | null,
  lastAuthSessionLoadedSignature: "",
  lastAppCaptureConfigSignature: "",
  lastClientContext: null as PostHogClientContext | null,
  lastIdentifiedDistinctId: null as string | null,
  lastOrganisationSignature: "",
  lastPersonPropertiesSignature: "",
  pendingAuthState: null as unknown,
  pendingEvents: [] as PendingPostHogEvent[],
  replayDisabled: false,
}

export function getPostHogClient() {
  return postHogState.client
}

export function queuePendingPostHogEvent(eventName: PostHogEventName, properties: Properties) {
  if (postHogState.replayDisabled) {
    return
  }

  postHogState.pendingEvents.push({ eventName, properties })
  if (postHogState.pendingEvents.length > MAX_PENDING_EVENT_COUNT) {
    postHogState.pendingEvents.shift()
  }
}

export function consumePendingPostHogEvents() {
  return postHogState.pendingEvents.splice(0)
}

export function setPendingPostHogAuthState(authState: unknown) {
  if (postHogState.replayDisabled) {
    return
  }

  postHogState.pendingAuthState = authState
}

export function consumePendingPostHogAuthState() {
  const authState = postHogState.pendingAuthState
  postHogState.pendingAuthState = null
  return authState
}

export function disablePendingPostHogReplay() {
  postHogState.replayDisabled = true
  postHogState.pendingAuthState = null
  postHogState.pendingEvents = []
}
